module.exports = __webpack_public_path__ + "static/img/landing-screen-v2-2.d6b4393.png";